import EFOcats_answer from './efocats_answer.js';
import EFOcats_import_html from '../import/efocats_import_html.js';

/**
 * 回答欄設置の共通処理（入力制限がある場合にテキストを表示とか）
 */
export default class EFOcats_answer_common extends EFOcats_answer {
  /**
   * 回答欄設置
   */
  set(tmp, answer, elem) {
    let input;

    if (answer.line !== undefined) {
      if (elem.find('.inner').length <= answer.line) {
        input = elem
          .find('.inner')
          .last()
          .after(EFOcats_import_html.getValue('common-question-double', {name: answer.name}));
      }

      input = elem
        .find('.inner')
        .eq(answer.line)
        .append(EFOcats_import_html.getValue('common-question', {name: answer.name}));

      this.attr(elem.find('.inner').eq(answer.line).find('input').last().get(0), answer, elem);

      elem.find('.cat-txt').eq(answer.line).attr('target-name', answer.name);
    } else {
      input = elem
        .find('.inner')
        .eq(0)
        .append(EFOcats_import_html.getValue('common-question', {name: answer.name}));
      this.attr(elem.find('.inner').eq(0).find('input').last().get(0), answer, elem);

      elem.find('.cat-txt').eq(0).attr('target-name', answer.name);
    }

    // maxlengthが設定されている時はバリデーションも設定する
    if (answer.maxlength !== undefined) {
      input.find('input').last().attr('data-maxlength', answer.maxlength);
    }

    // minlengthが設定されている時はバリデーションも設定する
    if (answer.minlength !== undefined) {
      input.find('input').last().attr('data-minlength', answer.minlength);
    }
  }
}
